import algoliasearch from 'algoliasearch';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { InstantSearch } from 'react-instantsearch-dom';
import { Autocomplete } from './components';

const Search = () => {
    const { i18n } = useTranslation();

    const algoliaClient = algoliasearch(process.env.GATSBY_ALGOLIA_CLIENT_ID, process.env.GATSBY_ALGOLIA_CLIENT_KEY);
    const searchClient = {
        ...algoliaClient,
        search(requests) {
            const requestsUpdated = requests.map((request) => ({
                ...request,
                params: {
                    ...request.params,
                    facetFilters: [[`locale:${i18n.language === 'es' ? 'es-US' : i18n.language}`]],
                },
            }));
            return algoliaClient.search(requestsUpdated);
        },
    };

    return (
        <InstantSearch indexName={process.env.GATSBY_ALGOLIA_INDEX_NAME} searchClient={searchClient}>
            <Autocomplete />
        </InstantSearch>
    );
};

export default Search;
